import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'solution-names-cell-viewer',
  templateUrl: './solution-names-cell-viewer.component.html',
  styleUrls: ['./solution-names-cell-viewer.component.scss']
})
export class SolutionNamesCellViewerComponent implements OnInit, CellComponent {

  item: any;
  fieldDefinition: FieldDefinition;

  constructor() {}

  ngOnInit() {
  }
}
